export const siteRegInputs = [
  {
    name: 'snils',
    label: 'СНИЛС',
    type: 'text',
    error: false,
    required: false,
  },
  {
    name: 'diplomaRegNumber',
    label: 'Рег. номер диплома и дата выдачи',
    type: 'text',
    error: false,
    required: false,
  },
  {
    name: 'diplomaQualification',
    label: 'Присвоенная квалификация в дипломе',
    type: 'text',
    error: false,
    required: false,
  },
  {
    name: 'diplomaSeries',
    label: 'Серия диплома',
    type: 'text',
    error: false,
    required: false,
  },
  {
    name: 'diplomaNumber',
    label: 'Номер диплома',
    type: 'text',
    error: false,
    required: false,
  },
];